import React, { useState } from 'react'
import MainLayout from '../Layouts/MainLayout'
import SubCategory from './SubCategory'

function SubCategoryContainer() {
  return (
    <MainLayout navTitle={"Sub Category"} navSubTitle={"Welcome to ImagesBazaar"}>
      <SubCategory/>
    </MainLayout>
  )
}

export default SubCategoryContainer